import React from 'react'
import { useLocation } from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'

// Route-level boundary: a render crash in one feature shows a Reload fallback
// for that feature instead of a blank app. Keyed on the path so opening
// another script clears it.
const FeatureBoundary = ({ feature, children }) => {
  const { pathname } = useLocation()
  return <ErrorBoundary feature={feature} resetKey={pathname}>{children}</ErrorBoundary>
}

export default FeatureBoundary
